import React from "react";
// Components
import FAQContentView from "components/CBFAQ/components/FAQContentView";
// Styled components
import { StyledSectionContainer } from "styles/components";
// Data
import ehrFaqData from "../../data/ehrFaq.data.json";
// import faqData from "utils/data/faqData/faq.json";

import withSectionAnimation from "styles/animations/components/withSectionAnimation";
import { fadeInReverseVariants } from "styles/animations/sectionFadeIn.animations";

// ! Removed allFaqData because we only show 5 results for faq, and since we removed the functionality to show new FAQs after clicking on a question, the user would never see the other FAQs.
// const allFaqData = [...ehrFaqData, ...faqData];
const AnimatedStyledSectionContainer = withSectionAnimation(StyledSectionContainer, fadeInReverseVariants);

const EHRFaq = () => {
  return (
    <AnimatedStyledSectionContainer id="ehr-faq-section">
      <FAQContentView initialCategory={"ehr-implementation"} textColor="#fff" faqData={ehrFaqData} component="h2" variant="h2" />
    </AnimatedStyledSectionContainer>
  );
};

export default EHRFaq;
